module.exports = __webpack_public_path__ + "static/media/crannog.dbe87022.png";